import {trackersSafeParams} from 'src/internal/platformMetrics/trackers';

export const PLATFORM_METRICS_REPORT_PARAMETERS = ['issued_at'] as const;

export const PLATFORM_METRICS_PARAMETERS = [
  ...trackersSafeParams,
  ...PLATFORM_METRICS_REPORT_PARAMETERS,
];
